import React, { useState } from 'react';
import {
  Box, Typography, Dialog, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AnnouncementBanner = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#F0F4FF',
          borderRadius: '12px',
          padding: '24px',
          mt: 3,
        }}
      >
        <Typography variant="bodyBold" sx={{ mb: 1 }}>
          Welcome to the new Zicasso platform!
        </Typography>
        <Typography variant="body">
          This is your new, dedicated space for managing your Zicasso trips. To learn more about the platform,
          {' '}
          <Box
            component="span"
            onClick={() => setIsVideoOpen(true)}
            sx={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              cursor: 'pointer',
              color: 'inherit',
            }}
          >
            click here
          </Box>
          {' '}
          to view our walkthrough video.
        </Typography>
        <Typography variant="body">
          <b>Important: </b>
          If you already have an active trip, please note that all previous email communications are not included in the Zicasso platform.
        </Typography>
      </Box>
      <Dialog
        open={isVideoOpen}
        onClose={() => setIsVideoOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            overflow: 'visible',
            bgcolor: 'black',
          },
        }}
      >
        <IconButton
          onClick={() => setIsVideoOpen(false)}
          sx={{
            position: 'absolute',
            right: 0,
            top: -45,
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            aspectRatio: '16/9',
            width: '100%',
          }}
        >
          <iframe
            style={{
              border: 0,
              width: '100%',
              height: '100%',
              borderRadius: '8px',
            }}
            src="https://www.youtube.com/embed/wOu3CheD91I?si=AnYbEXFC24Npf2Vg"
            title="Zicasso Platform - Walkthrough"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </Box>
      </Dialog>
    </>
  );
};

export default AnnouncementBanner;
